import { useAtomValue } from 'jotai';
import { rolloutsAtom } from '../../atoms';

export const useRollouts = () => useAtomValue(rolloutsAtom);
